/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioCashAccountCreateRequest } from './PortfolioCashAccountCreateRequest';
import {
    PortfolioCashAccountCreateRequestFromJSON,
    PortfolioCashAccountCreateRequestFromJSONTyped,
    PortfolioCashAccountCreateRequestToJSON,
    PortfolioCashAccountCreateRequestToJSONTyped,
} from './PortfolioCashAccountCreateRequest';

/**
 * 
 * @export
 * @interface PortfolioCashAccountBatchRequest
 */
export interface PortfolioCashAccountBatchRequest {
    /**
     * One or more cash accounts to create or update in a single call
     * @type {Array<PortfolioCashAccountCreateRequest>}
     * @memberof PortfolioCashAccountBatchRequest
     */
    cashAccounts: Array<PortfolioCashAccountCreateRequest>;
}

/**
 * Check if a given object implements the PortfolioCashAccountBatchRequest interface.
 */
export function instanceOfPortfolioCashAccountBatchRequest(value: object): value is PortfolioCashAccountBatchRequest {
    if (!('cashAccounts' in value) || value['cashAccounts'] === undefined) return false;
    return true;
}

export function PortfolioCashAccountBatchRequestFromJSON(json: any): PortfolioCashAccountBatchRequest {
    return PortfolioCashAccountBatchRequestFromJSONTyped(json, false);
}

export function PortfolioCashAccountBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCashAccountBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cashAccounts': ((json['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestFromJSON)),
    };
}

export function PortfolioCashAccountBatchRequestToJSON(json: any): PortfolioCashAccountBatchRequest {
    return PortfolioCashAccountBatchRequestToJSONTyped(json, false);
}

export function PortfolioCashAccountBatchRequestToJSONTyped(value?: PortfolioCashAccountBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cashAccounts': ((value['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestToJSON)),
    };
}

